import React, { Component } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Reroll,
  WEAPON_KEYWORD_OPTIONS
} from "@dndModels";
import { 
  DAMAGE_TYPES
} from "@dndModels/Constants";

import StringBox from "@components/input/strings/StringBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";

import SelectArmorTypeBox from "@dndComponents/select/SelectArmorTypeBox";
import SelectWeaponKeywordBox from "@dndComponents/select/SelectWeaponKeywordBox";

type Props = {
  obj: Reroll;
  onChange: (changed: Reroll) => void; 
  disabled: boolean;
}

export interface State { 
}

class RerollInput extends Component<Props, State> {
  public static defaultProps = {
    disabled: false
  };
  constructor(props: Props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  render() {
    return (
      <Grid container spacing={0} direction="column">
        <Grid>
          <SelectStringBox 
            name="Allowed Damage Types" 
            options={["ALL",...DAMAGE_TYPES]}
            values={this.props.obj.allowed_damage_types} 
            multiple
            disabled={this.props.disabled}
            onChange={(changed: string[]) => {
              const obj = this.props.obj;
              obj.allowed_damage_types = changed;
              this.props.onChange(obj);
            }} 
          />
        </Grid>
        <Grid>
          <SelectArmorTypeBox 
            name="Allowed Armor Types" 
            values={this.props.obj.allowed_armor_types} 
            multiple
            allow_all
            disabled={this.props.disabled}
            onChange={(changed: string[]) => {
              const obj = this.props.obj;
              obj.allowed_armor_types = changed;
              this.props.onChange(obj);
            }} 
          />
        </Grid>
        <Grid>
          <SelectArmorTypeBox 
            name="Required Armor Types" 
            values={this.props.obj.required_armor_types} 
            multiple
            allow_none
            allow_any
            disabled={this.props.disabled}
            onChange={(changed: string[]) => {
              const obj = this.props.obj;
              obj.required_armor_types = changed;
              this.props.onChange(obj);
            }} 
          />
        </Grid>
        <Grid>
          <SelectWeaponKeywordBox 
            name="Excluded Weapon Keywords" 
            values={this.props.obj.excluded_weapon_keywords} 
            multiple
            allow_none
            allow_any
            allow_all
            disabled={this.props.disabled}
            onChange={(changed: string[]) => {
              const obj = this.props.obj;
              obj.excluded_weapon_keywords = changed;
              this.props.onChange(obj);
            }} 
          />
        </Grid>
        <Grid>
          <SelectStringBox 
            name="Required Weapon Keywords" 
            options={WEAPON_KEYWORD_OPTIONS}
            values={this.props.obj.required_weapon_keywords} 
            multiple
            disabled={this.props.disabled}
            onChange={(changed: string[]) => {
              const obj = this.props.obj;
              obj.required_weapon_keywords = changed;
              this.props.onChange(obj);
            }} 
          />
        </Grid>
        <Grid>
          <StringBox 
            name="Threshold" 
            value={`${this.props.obj.threshold}`} 
            type="number"
            disabled={this.props.disabled}
            onBlur={(changed: string) => {
              const obj = this.props.obj;
              obj.threshold = +changed;
              this.props.onChange(obj);
            }} 
          />
        </Grid>
      </Grid>
    );
  }
}

export default RerollInput;
